import { useEffect, useRef } from 'react';

const KONAMI_SEQUENCE = [
	'ArrowUp',
	'ArrowUp',
	'ArrowDown',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
	'ArrowLeft',
	'ArrowRight',
	'KeyB',
	'KeyA',
];

export const useKonamiCode = (onActivate: () => void): void => {
	const indexRef = useRef(0);

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent): void => {
			if (e.code === KONAMI_SEQUENCE[indexRef.current]) {
				indexRef.current++;
				if (indexRef.current === KONAMI_SEQUENCE.length) {
					indexRef.current = 0;
					onActivate();
				}
			} else {
				indexRef.current = 0;
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [onActivate]);
};
